import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import {
  Grid,
  FormControl,
  TextField,
  Divider,
  Typography,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AdapterDayjsBuddhist } from "./AdapterDayjsBuddhist";
import FormPersonal from "./FormPersonal";
import FormLegalEntity from "./FormLegalEntity";
import { FormData, IProvince } from "./MainFormPersonaNewV1";
import dayjs from "dayjs";
import "dayjs/locale/th";

interface IDataMainFormPersonaNew {
  formData: FormData;
  setFormData: any;
  errors: any;
  setErrors: any;
  allProvince: IProvince[];
}

const FormPersonalInfoV1: React.FC<IDataMainFormPersonaNew> = ({
  formData,
  setFormData,
  errors,
  setErrors,
  allProvince,
}) => {
  const validateCid = (cid: string) => {
    const regex = /^[1-9]{1}[0-9]{12}$/;
    return regex.test(cid);
  };
  const validateAge = (age: string): boolean => {
    if (!age || age.trim() === "") return false; // กันเคสค่าว่าง
    const regex = /^\d+$/;
    return regex.test(age.trim()); // trim() ตัดเว้นวรรคซ้ายขวา
  };

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const regex = /^[a-zA-Zก-๙\s]+$/;
    const regex_license_code = /^[ก-ฮa-zA-Z0-9]{5,10}$/;

    setFormData((prev: { current_address: any }) => ({
      ...prev,
      [name]: value,
      // current_address: {
      //     ...prev.current_address,
      //     [name]: value, // อัปเดตฟิลด์ที่เปลี่ยนแปลงใน current_address
      // },
    }));
    // }

    // อัปเดต errors

    if (name === "full_cid" && !isValidThaiIdCard(value)) {
      setErrors((prevErrors: any) => ({ ...prevErrors, full_cid: true }));
  } else if (name === "age" && !validateAge(value)) {
      setErrors((prevErrors: any) => ({ ...prevErrors, age: true }));
  } else if (name === "nationality" && !regex.test(value)) {
      setErrors((prevErrors: any) => ({ ...prevErrors, nationality: true }));
  }else if (name === "license_code" && !regex_license_code.test(value)) {
    setErrors((prevErrors: any) => ({
      ...prevErrors,
      license_code: true,
    }));
  // } else if (name === "license_code" && !regex.test(value)) {
  //     const isValid = regex_license_code.test(value);
  //     setErrors((prevErrors: any) => ({
  //       ...prevErrors,
  //       license_code: !isValid,
  //     }));
  //     // setErrors((prevErrors: any) => ({ ...prevErrors, license_code: true }));

    } else {
      console.log("2 :>> ");
      setErrors((prevErrors: any) => {
        const newErrors = { ...prevErrors };
        // ตรวจสอบว่า value ของฟิลด์นี้มีค่าหรือไม่
        if (value.trim()) {
          delete newErrors[name]; // ถ้ามีค่าให้ลบข้อผิดพลาด
          delete newErrors[`current_address.${name}`];
        } else {
          newErrors[name] = true; // ถ้าไม่มีค่าให้แสดงข้อผิดพลาด
          newErrors[`current_address.${name}`] = true;
        }
        return newErrors;
      });
    }
  };
  const isValidThaiIdCard = (id: string): boolean => {
    if (!/^[1-9]\d{12}$/.test(id)) return false;

    let sum = 0;
    for (let i = 0; i < 12; i++) {
        sum += parseInt(id.charAt(i)) * (13 - i);
    }
    const checkDigit = (11 - (sum % 11)) % 10;

    return checkDigit === parseInt(id.charAt(12));
};
const isDateValid = (date: Date) => {
  const today = new Date();
  return date.getFullYear() <= today.getFullYear(); // จำกัดไม่ให้เลือกปีล่วงหน้า
};

  // const toBuddhistEra = (date: dayjs.Dayjs) => {
  //     return date.add(543, 'year');
  // };
  //      const handleDateChange = (newValue: dayjs.Dayjs | null) => {
  //     if (!newValue) {
  //       setFormData((prev: any) => ({
  //         ...prev,
  //         write_date: null,
  //       }));
  //       return;
  //     }

  //     // Convert the selected date to Buddhist Era (พ.ศ.)
  //     const buddhistDate = toBuddhistEra(newValue);
  //     console.log('Selected Date in Buddhist Era: ', buddhistDate.format("DD/MM/YYYY"));

  //     // Save the Buddhist Era date (Dayjs object) to state
  //     setFormData((prev: any) => ({
  //       ...prev,
  //       write_date: buddhistDate, // Store as Dayjs object
  //     }));
  //   };

  //   const convertToBE = (date: dayjs.Dayjs) => date.year(date.year() + 543);

  return (
    <form>
      <Grid
        item
        xs={12}
        md={10}
        sx={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Grid container spacing={2} sx={{ width: { xs: "100%", md: "65%" } }}>
          {/* ช่อง "เขียนที่" */}
          <Grid item xs={12} md={8}>
            <FormControl sx={{ minWidth: "100%" }}>
              <TextField
                variant="outlined"
                sx={{ backgroundColor: "#ffffff" }}
                label={
                  <span>
                    เขียนที่ <span style={{ color: "red" }}>*</span>
                  </span>
                }
                placeholder="กรุณากรอกสถานที่"
                value={formData.write_at || ""}
                name="write_at"
                onChange={handleFormChange}
                onInput={(e) => {
                  const input = e.target as HTMLInputElement;
                  input.value = input.value.trimStart();
                
                  // อัปเดตค่า input ใหม่
                  handleFormChange(e as React.ChangeEvent<HTMLInputElement>);
                }}
                error={errors.write_at}
                helperText={errors.write_at ? "กรุณากรอกสถานที่" : ""}
              />
            </FormControl>
          </Grid>

          {/* ช่อง "จดทะเบียนเมื่อ" */}
          <Grid item xs={12} md={4}>
            {/* {dayjs(formData.write_date).format("DD/MM/YYYY")} */}
            <FormControl sx={{ minWidth: "100%" }}>
              <LocalizationProvider
                dateAdapter={AdapterDayjsBuddhist}
                adapterLocale="th"
              >
                <DatePicker
                  label={
                    <span>
                      จดทะเบียนเมื่อ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  value={
                    formData.write_date ? dayjs(formData.write_date) : null
                  } // Ensure this is never undefined
                  onChange={(newValue) => {
                    if (newValue) {
                      // const formattedDate = convertToBE(newValue).format("DD/MM/YYYY");
                      // console.log("Updated write_date:", formattedDate);
                      setFormData((prev: any) => ({
                        ...prev,
                        write_date: newValue,
                      }));
                    }
                    // const formattedDate = newValue.add(543, 'year').format("DD/MM/YYYY");
                    // console.log("Updated write_date:", formattedDate);

                    // setFormData((prev: any) => ({
                    //   ...prev,
                    //   write_date: formattedDate,
                    // }));
                  }}
                  localeText={{ toolbarTitle: "กรุณาเลือกวันที่" }}
                  format="DD/MM/YYYY"
                  slots={{ textField: TextField }}
                  // shouldDisableDate={(date) => {
                  //     console.log("Checking date:", date.format("YYYY-MM-DD"));
                  //     return false;
                  //   }}
                  
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      variant: "outlined",
                      sx: { backgroundColor: "#ffffff" },
                      error: !!errors.write_date,
                      helperText: errors.write_date
                        ? "กรุณากรอกวันที่จดทะเบียน"
                        : "",
                    },
                  }}
                  disableFuture
                  // shouldDisableDate={(date) => !isDateValid(date.toDate())}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>

      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 3, rowGap: 1 }}>
        <Grid item xs={12} md={2} sx={{ alignSelf: "flex-start" }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            ข้อมูลส่วนตัว
          </Typography>
        </Grid>

        {/* กลุ่มฟอร์มกรอกข้อมูล */}
        <Grid item xs={12} md={10}>
          <Grid container spacing={2}>
            {/* ชื่อ */}
            <Grid item xs={12} md={4}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      ชื่อ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกชื่อ"
                  value={formData.firstname_th}
                  name="firstname_th"
                  // onChange={(e) => {
                  //   const inputValue = e.target.value;
                  //   const regex = /^[A-Za-zก-๙]*$/; // ตัวอักษรภาษาอังกฤษ และภาษาไทย
                  //   if (regex.test(inputValue)) {
                  //     // แคสประเภท event.target เป็น HTMLInputElement
                  //     handleFormChange(
                  //       e as React.ChangeEvent<HTMLInputElement>
                  //     );
                  //   }
                  // }}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const regex = /^[A-Za-z\u0E01-\u0E2E\u0E30-\u0E39\u0E47-\u0E4E\u0E3Aเแโใไ]*$/;
                
                    // ถ้าข้อความเป็นตัวอักษรเท่านั้น จะอัพเดตค่าใน form
                    if (regex.test(inputValue)) {
                      handleFormChange(
                        e as React.ChangeEvent<HTMLInputElement>
                      );
                    }
                  }}
                  error={errors.firstname_th}
                  helperText={errors.firstname_th ? "กรุณากรอกชื่อ" : ""}
                />
              </FormControl>
            </Grid>

            {/* นามสกุล */}
            <Grid item xs={12} md={4}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      นามสกุล <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกนามสกุล"
                  value={formData.lastname_th}
                  name="lastname_th"
                  // onChange={(e) => {
                  //   const inputValue = e.target.value;
                  //   const regex = /^[\u0E01-\u0E2E\u0E30-\u0E39\u0E47-\u0E4C\u0E4D\u0E3A\u0E45A-Za-z ]*$/;
                
                  //   // ถ้าข้อความเป็นตัวอักษรเท่านั้น จะอัพเดตค่าใน form
                  //   if (regex.test(inputValue)) {
                  //     handleFormChange(
                  //       e as React.ChangeEvent<HTMLInputElement>
                  //     );
                  //   }
                  // }}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const regex = /^[A-Za-z\u0E01-\u0E2E\u0E30-\u0E39\u0E47-\u0E4E\u0E3Aเแโใไ\s]*$/;
                  
                    if (regex.test(inputValue)) {
                      // เช็คจำนวน space
                      const spaceCount = (inputValue.match(/\s/g) || []).length;
                      // ห้ามเริ่มต้นด้วย space และspace แค่ 1 ครั้ง หลังจากมีตัวอักษรแล้ว
                      if (
                        !inputValue.startsWith(" ") &&        // ห้ามกด space เป็นตัวแรก
                        (spaceCount <= 2 || inputValue === "") // space ได้ไม่เกิน 2 ครั้ง
                      ) {
                        handleFormChange(e as React.ChangeEvent<HTMLInputElement>);
                      }
                    }
                  }}
                  
                  
                  error={errors.lastname_th}
                  helperText={errors.lastname_th ? "กรุณากรอกนามสกุล" : ""}
                />
              </FormControl>
            </Grid>

            {/* อายุ */}
            <Grid item xs={12} md={2}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      อายุ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกอายุ"
                  value={formData.age}
                  name="age"
                  inputProps={{
                    pattern: "[0-9]*",
                    inputMode: "numeric",
                  }}
                  onChange={handleFormChange}
                  onInput={(e) => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value.replace(/[^0-9]/g, "");
                  }}
                  // onChange={(e) => {
                  //   const inputValue = e.target.value;
                  //   const cleanedValue = inputValue.replace(/[^ก-๙a-zA-Z ]/g, ''); // กรองเฉพาะไทย, อังกฤษ, เว้นวรรค
                  //   const event = {
                  //     ...e,
                  //     target: {
                  //       ...e.target,
                  //       value: cleanedValue,
                  //     },
                  //   } as React.ChangeEvent<HTMLInputElement>;
                  //   handleFormChange(event);
                  // }}
                  error={!!errors.age || Number(formData.age) < 20} // ตรวจสอบอายุ < 20
                  helperText={errors.age || Number(formData.age) < 20 ? "กรุณากรอกอายุที่มากกว่าหรือเท่ากับ 20 ปี" : ""}
                />
              </FormControl>
            </Grid>

            {/* สัญชาติ */}
            <Grid item xs={12} md={2}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      สัญชาติ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกสัญชาติ"
                  value={formData.nationality}
                  name="nationality"
                  // onChange={handleFormChange}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const regex = /^[A-Za-z\u0E01-\u0E2E\u0E30-\u0E39\u0E47-\u0E4E\u0E3Aเแโใไ]*$/; // ตัวอักษรไทยและอังกฤษ ไม่รวมเว้นวรรค
                  
                    if (regex.test(inputValue)) {
                      handleFormChange(e as React.ChangeEvent<HTMLInputElement>);
                    }
                  }}
                  error={errors.nationality}
                  helperText={errors.nationality ? "กรุณากรอกสัญชาติ" : ""}
                />
              </FormControl>
            </Grid>

            {/* เลขประจำตัวประชาชน */}
            <Grid item xs={12} md={6}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      เลขประจำตัวประชาชน <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกเลขประจำตัวประชาชน"
                  value={formData.full_cid}
                  name="full_cid"
                  onChange={handleFormChange}
                  onInput={(e) => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 13);
                  }}
                  error={errors.full_cid}
                  inputProps={{
                    maxLength: 13,
                    pattern: "[0-9]*",
                    inputMode: "numeric",
                  }}
                  helperText={
                    errors.full_cid ? "กรุณากรอกเลขประจำตัวประชาชน" : ""
                  }
                />
              </FormControl>
            </Grid>

            {/* เลขที่ใบอนุญาตประกอบวิชาชีพ */}
            <Grid item xs={12} md={6}>
            <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      เลขที่ใบอนุญาติประกอบวิชาชีพ{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกเลขที่ใบอนุญาติประกอบวิชาชีพ"
                  value={formData.license_code}
                  name="license_code"
                  onChange={handleFormChange}
                  error={errors.license_code}
                  onInput={(e) => {
                    const input = e.target as HTMLInputElement;
                  
                    // ตัดช่องว่างข้างหน้าและข้างหลัง
                    input.value = input.value.trim();
                  
                    // กรองให้เหลือเฉพาะ ภาษาไทย (ก-ฮ), อังกฤษ, และเลขอารบิก เท่านั้น
                    input.value = input.value.replace(/[^ก-ฮa-zA-Z0-9]/g, "").slice(0, 10);
                  
                    // ตรวจสอบว่าความยาวอยู่ระหว่าง 5-10 ตัวอักษร
                    const regex = /^[ก-ฮa-zA-Z0-9]{5,10}$/;
                  
                    // ตรวจสอบว่าค่าที่กรอกตรงตาม regex และมีความยาว 5-10 ตัว
                    if (regex.test(input.value) && input.value.length >= 5) {
                      // อัพเดตฟอร์มเมื่อข้อมูลถูกต้อง
                      handleFormChange(e as React.ChangeEvent<HTMLInputElement>);
                    } 
                  }}
                  helperText={
                    errors.license_code
                      ? "กรุณากรอกเฉพาะตัวอักษรภาษาไทย ตัวเลข หรืออังกฤษ (5-10 ตัว)"
                      : ""
                  }
                  // helperText={
                  //   errors.license_code
                  //     ? "กรุณากรอกเลขที่ใบอนุญาติประกอบวิชาชีพ *"
                  //     : ""
                  // }
                  inputProps={{
                    maxLength: 10,
                    // pattern: "[a-zA-Zก-๙\\s]+",
                    // inputMode: "text"
                }}

                />
              </FormControl>

            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <FormLegalEntity
        formData={formData}
        setFormData={setFormData}
        setErrors={setErrors}
        errors={errors}
      />
      <FormPersonal
        setFormData={setFormData}
        allProvince={allProvince}
        formData={formData}
        errors={errors}
        setErrors={setErrors}
      />
    </form>
  );
};

export default FormPersonalInfoV1;
